import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-floating-button',
  templateUrl: './floating-button.component.html',
  styleUrls: ['./floating-button.component.scss']
})
export class FloatingButtonComponent implements OnInit {
  appTrackingUrl: string = environment.ADJUST_TRACKER_URL + "/" + environment.ADJUST_WEBSITE_TRACKER;
  showButton: boolean = true;

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.appTrackingUrl.subscribe(value => {
      this.appTrackingUrl = value;
    });

    this.sharedService.showFloatingButton.subscribe(show => {
      this.showButton = show;
    });
  }

  downloadApp() {
    console.log(`url: ${this.appTrackingUrl}`);
    window.open(this.appTrackingUrl, "_blank");
  }
}
